import { render, staticRenderFns } from "./ItemPage.vue?vue&type=template&id=fa9a1988&scoped=true&"
import script from "./ItemPage.vue?vue&type=script&lang=js&"
export * from "./ItemPage.vue?vue&type=script&lang=js&"
import style0 from "./ItemPage.vue?vue&type=style&index=0&id=fa9a1988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9a1988",
  null
  
)

export default component.exports